<template>
	<ion-modal
		ref="modal"
		:keep-contents-mounted="true"
		@ion-modal-will-dismiss="onWillPresent"
	>
		<ion-header>
			<ion-toolbar>
				<ion-buttons slot="start">
					<ion-button color="dark" @click="cancel()">
						{{ $t("common.cancel") }}
					</ion-button>
				</ion-buttons>
				<ion-title>{{ title }}</ion-title>
				<ion-buttons slot="end">
					<ion-button @click="confirm()">{{
						$t("common.done")
					}}</ion-button>
				</ion-buttons>
			</ion-toolbar>
		</ion-header>
		<ion-datetime
			:id="datetimeId"
			v-model="localValue"
			presentation="date"
			:format-options="formatOptions"
			:min="min"
			:max="max"
		/>
	</ion-modal>
</template>

<script setup lang="ts">
	import {
		IonModal,
		IonHeader,
		IonToolbar,
		IonTitle,
		IonButtons,
		IonButton,
		IonDatetime,
	} from "@ionic/vue";
	import {
		DateString,
		getCurrentDateString,
	} from "seedgreen-shared/types/datestring.types";
	import { ref } from "vue";

	// Required to only select and display the date in the format of "dd MMM yyyy"
	const formatOptions: { date: Intl.DateTimeFormatOptions } = {
		date: {
			weekday: "short",
			month: "short",
			day: "2-digit",
			year: "numeric",
		},
	};

	defineProps<{
		datetimeId?: string;
		title?: string;
		min?: string;
		max?: string;
	}>();
	const modelValue = defineModel<DateString>();

	const localValue = ref<DateString>(
		modelValue.value ?? getCurrentDateString(),
	);

	const modal = ref();

	function onWillPresent() {
		localValue.value = modelValue.value ?? getCurrentDateString();
	}

	// Modal methods
	const open = () => {
		modal.value.$el.present();
	};
	const cancel = () => modal.value.$el.dismiss();
	const confirm = () => {
		modelValue.value = localValue.value;
		modal.value.$el.dismiss();
	};

	defineExpose({
		open,
	});
</script>

<style scoped>
	ion-modal {
		--height: auto;
		--width: auto;
	}
</style>
